import request from "./request";

// 官网公告列表
export function getWebNoticeList(data){
    return request({
      url: 'admin/Notice/getWebNoticeList',
      method: 'post',
      data:data
    })
}

// 官网公告详情
export function getWebNoticeDetail(data){
    return request({
      url: 'admin/Notice/getWebNoticeDetail',
      method: 'post',
      data:data
    })
}







// WEBPACK FOOTER //
// ./src/assets/js/api.js